import { useMutation } from 'react-query';
import {
  createEscolarManagerIntegrationAsync,
  deleteEscolarManagerIntegrationAsync,
  getAllEscolarManagerIntegrationsAsync,
  getEscolarManagerIntegrationByIdAsync,
  updateEscolarManagerIntegrationAsync,
} from '../../index';

export const useCreateEscolarManagerIntegrationAsync = () =>
  useMutation(createEscolarManagerIntegrationAsync);

export const useGetEscolarManagerIntegrationByIdAsync = () =>
  useMutation(getEscolarManagerIntegrationByIdAsync);

export const useGetAllEscolarManagerIntegrationsAsync = () =>
  useMutation(getAllEscolarManagerIntegrationsAsync);

export const useUpdateEscolarManagerIntegrationAsync = () =>
  useMutation(updateEscolarManagerIntegrationAsync);

export const useDeleteEscolarManagerIntegrationAsync = () =>
  useMutation(deleteEscolarManagerIntegrationAsync);
